import { all, call, put, takeLatest } from "redux-saga/effects";

import { toast } from "react-toastify";
import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { getEmployeeFeedbackDetailApi } from "core/http/service/employeeRequest";
import {
  getEmployeeFeedbackFailed,
  getEmployeeFeedbackStart,
  getEmployeeFeedbackSuccess,
} from "../redux/getEmployeeFeedbackDetail";

function* getEmployeeFeedbackWork(action) {
  const { id, callback } = action.payload;

  try {
    const res = yield call(getEmployeeFeedbackDetailApi, id);

    yield put({
      type: getEmployeeFeedbackSuccess.type,
      payload: res,
    });
    if (callback) {
      callback(res);
    }
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: getEmployeeFeedbackFailed.type,
      payload: ErrorMessage[error?.response?.data?.code] ?? "Có lỗi xảy ra",
    });
  }
}

function* watchGetEmployeeFeedback() {
  yield takeLatest(getEmployeeFeedbackStart.type, getEmployeeFeedbackWork);
}

export default function* getEmployeeEmployeeFeedbackSaga() {
  yield all([watchGetEmployeeFeedback()]);
}
